import React from 'react';
import Component from '@vfuk/core-horizontal-stepper';
const CoreHorizontalStepper = props => {
    return React.createElement(Component, Object.assign({}, props));
};
export default CoreHorizontalStepper;
